export const GET_ASSESSMENT_FLOW_QUESTIONS = 'GET_ASSESSMENT_FLOW_QUESTIONS'
export const RESET_ASSESSMENT = 'RESET_ASSESSMENT'
export const GET_ASSESSMENT_LIST = 'GET_ASSESSMENT_LIST'
export const GET_ASSESSMENT_SECTION_QUESTIONS = 'GET_ASSESSMENT_SECTION_QUESTIONS'
